import { render } from "./EditorJodit.vue?vue&type=template&id=04f310df&scoped=true"
import script from "./EditorJodit.vue?vue&type=script&lang=js"
export * from "./EditorJodit.vue?vue&type=script&lang=js"

import "./EditorJodit.vue?vue&type=style&index=0&id=04f310df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f310df"]])

export default __exports__